import { combineReducers } from 'redux';

import { reduxActions } from '../constants';

import { appState } from './route-reducer';
import { menuToggleState } from './nav-reducer';
import { faqList } from './faq-reducer';
import { registerAccount, loginStatus, activeUser, registerStatus, verifyStatus, passwordRecoveryStatus, passwordResetStatus, passwordChangeStatus, userSecurity } from './account-reducer';
import { fetchState } from './resource-reducer';
import { userApprovalQueue, adminUserList, adminTabState, adminRevokedUserList } from './user-management-reducer';
import { completedReports, pendingSamples, reportAccess, reportData, completedReportSearchExport, pendingReportSearchExport } from './report-reducer';
import { growlList, nextGrowlId } from './growl-reducer';

const appReducer = combineReducers({
    appState,
    menuToggleState,
    faqList,
    registerAccount,
    loginStatus,
    activeUser,
    registerStatus,
    verifyStatus,
    fetchState,
    userApprovalQueue,
    completedReports,
    pendingSamples,
    reportAccess,
    reportData,
    passwordRecoveryStatus,
    passwordResetStatus,
    passwordChangeStatus,
    adminUserList,
    adminRevokedUserList,
    adminTabState,
    growlList,
    nextGrowlId,
    completedReportSearchExport,
    pendingReportSearchExport,
    userSecurity
});

const rootReducer = (state, action) => {
    // End it all when the user logs out.
    if (action.type === reduxActions.END_SESSION) {
        state = undefined;
    }

    return appReducer(state, action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./web-app/reducers/index.js